var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from "../../../../../common/components/base.component";
import { config } from "../../../../../../config/config";
import { EventTimeService } from "../../../../../services/event.time.service";
import { CustomizationApiService } from "../../../../../services/customization.api.service";
import { HubApiService } from "../../../../../services/hub.api.service";
import { StyleCommand, StyleModel } from "../../../../../commands/hub/style.command";
var TripPlannerColorSettingsComponent = /** @class */ (function (_super) {
    __extends(TripPlannerColorSettingsComponent, _super);
    function TripPlannerColorSettingsComponent(hubApiService, formBuilder, activatedRoute, customizationService, cd) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.customizationService = customizationService;
        _this.cd = cd;
        _this.hubName = null;
        _this.defaultImg = config.defaultImageUrl;
        _this.tourSideImg = config.tripPlannerTourSideImg;
        _this.mapImg = config.mapImg;
        _this.tpBG = config.tripPlannerWelcomeImg;
        _this.timeSample = EventTimeService.convert(new Date());
        _this.previewSelectedTab = 'event';
        _this.style = new StyleModel();
        _this.onSave = new EventEmitter();
        return _this;
    }
    TripPlannerColorSettingsComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
    };
    Object.defineProperty(TripPlannerColorSettingsComponent.prototype, "leftPartWidth", {
        get: function () {
            return this.isOnTourOrTrip ? '29%' : '60%';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripPlannerColorSettingsComponent.prototype, "rightPartWidth", {
        get: function () {
            return this.isOnTourOrTrip ? '70%' : '39%';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripPlannerColorSettingsComponent.prototype, "isOnTourOrTrip", {
        get: function () {
            return this.isOnTour || this.isOnTrip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripPlannerColorSettingsComponent.prototype, "isOnTour", {
        get: function () {
            return this.previewSelectedTab === 'tour';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripPlannerColorSettingsComponent.prototype, "isOnTrip", {
        get: function () {
            return this.previewSelectedTab === 'trip';
        },
        enumerable: true,
        configurable: true
    });
    TripPlannerColorSettingsComponent.prototype.toDefault = function (type) {
        var defaultStyle = new StyleModel();
        this.style.tripPlanner[type].color.value = defaultStyle.tripPlanner[type].color.value;
    };
    TripPlannerColorSettingsComponent.prototype.saveColor = function (event) {
        var _this = this;
        var colorCmd = new StyleCommand();
        Object.keys(colorCmd.tripPlanner).forEach(function (x) {
            colorCmd.tripPlanner[x].color = _this.style.tripPlanner[x].color.isDefault ? '' : _this.style.tripPlanner[x].color.value;
            delete colorCmd.tripPlanner[x].isDefault;
        });
        this.onSave.emit({ command: colorCmd, event: event });
    };
    TripPlannerColorSettingsComponent.prototype.chooseColor = function () { };
    return TripPlannerColorSettingsComponent;
}(BaseComponent));
export { TripPlannerColorSettingsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/customization/style/trip.planner.color.settings/trip.planner.color.settings.component.ts.pre-build-optimizer.js